import React, { useState, useEffect, useRef } from 'react';
import { useRecoilState } from 'recoil';
import { speedStringByType } from '../../plugins/common';
import { bedInfoState, wardState, selectBedInfoState, measurementStateFamily, deviceModelInfo } from '../../plugins/recoil';
import { useTranslation } from 'react-i18next';
import axios from '../../plugins/axios'
import Toast from '../../plugins/useToast';

import AlarmSettings from './components/AlarmSettings';
import PatientInfoSettings from './components/PatientInfoSettings';
import DisplaySettings from './components/DisplaySettings';
import Confirm from './components/Patient/Confirm';
import Transfer from './components/Patient/Transfer';
import HalfMenus from '../../components/halfMenus';

import {ReactComponent as IconInit} from '../../assets/icons/ic-init.svg';
import { checkEmptyValue, activeTabStyle, inActiveTabStyle } from '../../plugins/common';

const defaultMeasurementSettings = {
    lead1SweepSpeed: 25,
    lead2SweepSpeed: 25,
    lead3SweepSpeed: 25,
    plethSweepSpeed: 25,
    respSweepSpeed: 25,
    capnoSweepSpeed: 25,
    ibp1SweepSpeed: 25,
    ibp2SweepSpeed: 25,
    ibp3SweepSpeed: 25,
    ibp4SweepSpeed: 25,
    gasAa1SweepSpeed: 25,
    gasAa2SweepSpeed: 25,
    gasCo2SweepSpeed: 25,
    gasN2oSweepSpeed: 25,
    gasO2SweepSpeed: 25,
    chestSweepSpeed: 25,
    padsPaddleSweepSpeed: 25,
}

const BedSettingsModal = ({ onClose, onTrend, onAlarmReview, onMeasurements, handleSaveParameter }) => {
    const { t } = useTranslation()
    const [activeTab, setActiveTab] = useState('patientInfo');
    const [newValue, setNewValue] = useState(null);
    const [curWard, ] = useRecoilState(wardState)
    const [bedInfo, setBedInfo] = useRecoilState(bedInfoState)
    const [selectBedInfo, setSelectBedInfo] = useRecoilState(selectBedInfoState)
    const [measurementSettings, setMeasurementSettings] = useRecoilState(measurementStateFamily(selectBedInfo?.serial));
    const [numericCodeList, setNumericCodeList] = useState([])
    const [waveCodeList, setWaveCodeList] = useState([])                
    const [isResetable, setIsResetable] = useState(false)
    const [vsmMode, setVsmMode] = useState(false);
    const isFirstRender = useRef(true);    
    const isDisabledRef = useRef(true)
    const displayOldInfo = useRef({})
    const defaultWaveCodeListRef = useRef([]);
    const defaultNumericCodeListRef = useRef([]);
    const defaultVsmNumericCodeListRef = useRef([]);
    const [waveArr, setWaveArr] = useState([])
    const [numericArr, setNumericArr] = useState([])
    const [confirmState, setConfirmState] = useState({open : false,title : '', message : '', onYes : null , onNo : null}) // Confirm 상태 관리
    const [deviceInfo , setDeviceInfo] = useState();    
    const [confirmTransfer, setConfirmTransfer] = useState({open : false,step : 1})
    const [transferPatientInfo, setTransferPatientInfo] = useState(); //선택한 Ward와 Bed 정보 저장        
    const [applyToAllBed, setApplyToAllBed] = useState(false)
    const [deviceModelMenus, ] = useRecoilState(deviceModelInfo);
    const [isShowDisplay, setIsShowDisplay] = useState(true)

    //VSM MODE Toggle
    const handleVsmMode = (isVsmMode) => {
        setVsmMode(isVsmMode);
        setBedInfo(prev => {
            return prev.map(group => 
                group.map(item => {
                    if (item.serial === selectBedInfo.serial) {
                        const newNumericCodeList = isVsmMode ? defaultVsmNumericCodeListRef.current.map(ns => ns.measureParameter) : defaultNumericCodeListRef.current.map(ns => ns.measureParameter)
                        const newWaveCodeList = isVsmMode ? item.waveCodeList : defaultWaveCodeListRef.current.map(ws => ws.measureParameter)
                        return { ...item, vsmMode: isVsmMode, numericCodeList: newNumericCodeList, waveCodeList: newWaveCodeList }
                    } else {
                        return item
                    }
                })
            )
        })                
    }
    
    const setVsmModeDisplay = async () =>{                   
        if(vsmMode){                                    
            setNumericArr(defaultVsmNumericCodeListRef.current)
        }else{                        
            setNumericArr(defaultNumericCodeListRef.current)
            setWaveArr(defaultWaveCodeListRef.current)
        }
    }

    const handleIsDisabled = (boolean) => {
        isDisabledRef.current = boolean;
    }

    /* display - start */    
    //Data 변경
    const handleChangeSelect = (type,index,value,tagName) => {
        isDisabledRef.current && (isDisabledRef.current = !isDisabledRef.current);
        if(type == 'Wave'){
            const newWaveArr = [...waveArr]
            newWaveArr[index] = { ...newWaveArr[index],  measureParameterId : value , measureParameter : tagName};
            setWaveArr(newWaveArr);
            setBedInfo(prev => {
                return prev.map(group => 
                    group.map(item => {
                        if (item.serial === selectBedInfo.serial) {
                            return { ...item, waveCodeList: newWaveArr.map(ws => ws.measureParameter) }
                        } else {
                            return item
                        }
                    })
                )
            })              
        }
        else if(type == 'Numeric'){
            const newNumericArr = [...numericArr]
            newNumericArr[index] = { ...newNumericArr[index], measureParameterId : value , measureParameter : tagName };
            setNumericArr(newNumericArr);
            setBedInfo(prev => {
                return prev.map(group => 
                    group.map(item => {
                        if (item.serial === selectBedInfo.serial) {
                            return { ...item, numericCodeList: newNumericArr.map(ns => ns.measureParameter) }
                        } else {
                            return item
                        }
                    })
                )
            })              
        }
    }

    const handleChangeSpeedSelect = (waveType, index, value) => {
        isDisabledRef.current && (isDisabledRef.current = !isDisabledRef.current);
        setMeasurementSettings(prev => {
            return {
                ...prev,
                [speedStringByType[waveType]]: value
            }
        }) 
    }

    //저장 버튼
    const handleDisplaySave = async () =>{     
        try{
            let waveParams = [];
            let numericParams = [];
            if(vsmMode){
                numericParams = [...numericArr].map(({ displayOrder,measureParameterId }) => ({                    
                    displayOrder,
                    measureParameterId
                }));
            }else{
                waveParams = [...waveArr].map(({ displayOrder,measureParameterId, measureParameter }) => ({                    
                    displayOrder,
                    measureParameterId,
                    swapSpeed: measurementSettings[speedStringByType[measureParameter]] || 25
                }));
                numericParams = [...numericArr].map(({ displayOrder,measureParameterId }) => ({                    
                    displayOrder,
                    measureParameterId
                }));
            }   
            
            const vsmParam = vsmMode;

            const res = await axios.put(applyToAllBed ? `/user/devices/display?wardId=${curWard.value === 'ICU' ? 1 : curWard.value}` : `/user/device/${selectBedInfo.deviceId}/display`, { vsmMode : vsmParam, waveSettings : waveParams, numericSettings : numericParams })
            if (res.code != '200') throw Toast({ isSuccess: false, msg : res });
            
            Toast({ isSuccess: true });
            isDisabledRef.current = true; //저장 버튼 비활성화
            if (applyToAllBed) {
                setApplyToAllBed(false)
            }
            handleSaveParameter()
            displayOldInfo.current = {
                vsmMode: vsmParam,
                waveArr: waveArr,
                numericArr: numericArr,
                measurementSettings: { ...measurementSettings }
            }
            //getDeviceData(selectBedInfo.deviceId);
        }
        catch (err) {
            console.warn(err)
        }
    }
    
    //Rodney - 초기화 버튼 수정해야됨.
    const handleInit = () =>{  
        if(vsmMode){
            isDisabledRef.current = false;                    
            setNumericArr(defaultVsmNumericCodeListRef.current);
            setBedInfo(prev => {
                return prev.map(group => 
                    group.map(item => {
                        if (item.serial === selectBedInfo.serial) {
                            return { ...item, numericCodeList: defaultVsmNumericCodeListRef.current.map(ns => ns.measureParameter) }
                        } else {
                            return item
                        }
                    })
                )
            })  
        }
        else{
            setVsmMode(false)
            isDisabledRef.current = false;              
            setNumericArr(defaultNumericCodeListRef.current)
            setWaveArr(defaultWaveCodeListRef.current)
            setMeasurementSettings(prev => {
                return {
                    ...prev,
                    ...defaultMeasurementSettings.current
                }
            })
            setBedInfo(prev => {
                return prev.map(group => 
                    group.map(item => {
                        if (item.serial === selectBedInfo.serial) {
                            return { ...item, numericCodeList: defaultNumericCodeListRef.current.map(ns => ns.measureParameter), waveCodeList: defaultWaveCodeListRef.current.map(ws => ws.measureParameter) }
                        } else {
                            return item
                        }
                    })
                )
            })
        }
    }

    // Wave Drag 함수
    const onDragWaveEnd = (result) => {
        const { source, destination } = result;

        // 드래그가 이상한 곳에 있을 경우 return 시켜줌
        if (!destination) return;

        const sourceIndex = source.index;
        const destinationIndex = destination.index;
        const allArr = [...waveArr];
        let movedItem;

        movedItem = allArr.splice(sourceIndex, 1)[0];
        allArr.splice(destinationIndex, 0, movedItem);

        const newWaveArr = allArr.map((item, index) => ({
            ...item,
            displayOrder: index + 1, // 1부터 시작
        }));

        setWaveArr(newWaveArr);
        isDisabledRef.current = false;
        setBedInfo(prev => {
            return prev.map(group => 
                group.map(item => {
                    if (item.serial === selectBedInfo.serial) {
                        return { ...item, waveCodeList: newWaveArr.map(ws => ws.measureParameter) }
                    } else {
                        return item
                    }
                })
            )
        })
    }

    // 뉴메릭 Drag 함수
    const onDragNumericEnd = (result) => {
        const { source, destination } = result;
    
        // 드래그가 이상한 곳에 있을 경우 return 시켜줌
        if (!destination) return;
    
        const sourceIndex = source.index;
        const destinationIndex = destination.index;
        const allArr = [...numericArr];
        let movedItem;
    
        // 컬럼 간 이동
        if (source.droppableId !== destination.droppableId) {
            // 왼쪽에서 오른쪽으로 이동 = left ,  // 오른쪽에서 왼쪽으로 이동  = right
            if (source.droppableId === "left") {                
                movedItem = allArr.splice(sourceIndex, 1)[0]; 
                allArr.splice(destinationIndex-1, 0, movedItem); 
            } else {                
                movedItem = allArr.splice(sourceIndex, 1)[0];
                allArr.splice(destinationIndex, 0, movedItem); 
            }
        } else { // 같은 컬럼 내에서 이동
            movedItem = allArr.splice(sourceIndex, 1)[0]; 
            allArr.splice(destinationIndex, 0, movedItem); 
        }
    
        // 왼쪽과 오른쪽 배열을 합친 후 displayOrder 정렬
        const newNumericArr = allArr.map((item, index) => ({
            ...item,
            displayOrder: index + 1, // 1부터 시작
        }));
    
        setNumericArr(newNumericArr);
        isDisabledRef.current = false;
        setBedInfo(prev => {
            return prev.map(group => 
                group.map(item => {
                    if (item.serial === selectBedInfo.serial) {
                        return { ...item, numericCodeList: newNumericArr.map(ns => ns.measureParameter) }
                    } else {
                        return item
                    }
                })
            )
        })  
    };

    // 뉴메릭 vsmMode On인 경우 
    // const onDragVsmNumeric = (result) => {
    //     const { source, destination } = result;

    //     // 드래그가 이상한 곳에 있을 경우 return 시켜줌
    //     if (!destination) return;

    //     const sourceIndex = source.index;
    //     const destinationIndex = destination.index;
    //     const allArr = [...numericArr];    
    //     let movedItem;

    //     movedItem = allArr.splice(sourceIndex, 1)[0]; 
    //     allArr.splice(destinationIndex, 0, movedItem); 

    //     const newNumericArr = allArr.map((item, index) => ({
    //         ...item,
    //         displayOrder: index + 1, // 1부터 시작
    //     }));        
        
    //     setNumericArr(newNumericArr);        
    //     setIsDisabled(false);
    // }
    /* display - end */

    const handleClose = () => {
        onClose(newValue);
    };

    const renderTabContent = () => {
        switch (activeTab) {
            case 'patientInfo':                
                return <PatientInfoSettings selectBedInfo={selectBedInfo} deviceInfo={deviceInfo} handleConfirm={handleConfirm} handleDeviceDataChange={handleDeviceDataChange} onClose={onClose} handleSaveParameter={handleSaveParameter} handleConfirmTransfer={handleConfirmTransfer} handleSaveSuccess={handleSaveSuccess} deviceModelMenus={deviceModelMenus}/>;
            case 'alarm':                
                // return <AlarmSettingsV2 selectBedInfo={selectBedInfo} onSaveSuccess={handleSaveSuccess}/>;
                return <AlarmSettings deviceInfo={deviceInfo} selectBedInfo={selectBedInfo} handleSaveParameter={handleSaveParameter} deviceModelMenus={deviceModelMenus}/>; 
            case 'display':
                return <DisplaySettings waveArr={waveArr} numericArr={numericArr} handleIsDisabled={handleIsDisabled} handleChangeSelect={handleChangeSelect} handleChangeSpeedSelect={handleChangeSpeedSelect} numericCodeList={numericCodeList} waveCodeList={waveCodeList} vsmMode={vsmMode} handleVsmMode={handleVsmMode} onDragWaveEnd={onDragWaveEnd} onDragNumericEnd={onDragNumericEnd} />;
            // 다른 탭 컴포넌트 추가
            default:
                return null;
        }
    };

    const handleSaveSuccess = (updatedSelectBedInfo) => {
        setSelectBedInfo(updatedSelectBedInfo);
    };

    //Confirm 창 handler
    const handleConfirm = (title, message, onYes, onNo) => {
        setConfirmState({
            open: true,
            title : title,
            message : message,
            onYes: () => {
                setConfirmState(prev => ({ ...prev, open: false })); // 모달 닫기
                if (onYes) onYes(); // 실제 onYes 실행
            },
            onNo: () => {
                setConfirmState(prev => ({ ...prev, open: false })); // 모달 닫기
                if (onNo) onNo(); // 실제 onNo 실행
            }
        });
    }

    //handleTransferConfirm - patientInfo : 환자 정보
    const handleConfirmTransfer = async (patientInfo) => {        
        try {
            setConfirmTransfer({
                open: true,      
                step : 1, // Step 1로 초기화
            })
            setTransferPatientInfo(patientInfo);
        } catch (err) {
            console.warn(err)
        }
    }

    //confirmTransfer State 변경
    const handleSetConfirmTransfer = (open, step) => {
        setConfirmTransfer(prev => ({ ...prev, open, step }));
    }

    //Rodney - Default 가져오게 되면 수정 해야 됨.
    const checkResetable = () => {
        if(vsmMode){
            const selectedNumericCodeArr = numericArr.map(numericItem => numericItem.measureParameterId)            
            const defaultNumericCodeArr = defaultVsmNumericCodeListRef.current.map(numericItem => numericItem.measureParameterId)
            
            if (selectedNumericCodeArr.length !== defaultNumericCodeArr.length) {
                setIsResetable(true)
                return
            }
        
            if (!selectedNumericCodeArr.every((value, index) => value === defaultNumericCodeArr[index])) {
                setIsResetable(true)
                return
            }

            setIsResetable(false)
        }else{
            const selectedWaveCodeArr = waveArr.map(waveItem => waveItem.measureParameterId)
            const selectedNumericCodeArr = numericArr.map(numericItem => numericItem.measureParameterId)

            const defaultWaveCodeArr = defaultWaveCodeListRef.current.map(waveItem => waveItem.measureParameterId)
            const defaultNumericCodeArr = defaultNumericCodeListRef.current.map(numericItem => numericItem.measureParameterId)

            if (selectedWaveCodeArr.length !== defaultWaveCodeArr.length) {
                setIsResetable(true)
                return
            }
        
            if (!selectedWaveCodeArr.every((value, index) => value === defaultWaveCodeArr[index])) {
                setIsResetable(true)
                return
            }

            if (selectedNumericCodeArr.length !== defaultNumericCodeArr.length) {
                setIsResetable(true)
                return
            }
        
            if (!selectedNumericCodeArr.every((value, index) => value === defaultNumericCodeArr[index])) {
                setIsResetable(true)
                return
            }

            for (const key in defaultMeasurementSettings) {
                if (measurementSettings[key] !== defaultMeasurementSettings[key]) {
                    setIsResetable(true)
                    return
                }
            }

            setIsResetable(false)
        }
    }

    //as-is Deivce Data 가져오기
    const getDeviceData = async (deviceId) => {
        try {   
            //device 정보         
            const deviceRes = await axios.get(`/device/${deviceId}`);
            if (deviceRes.code != '200') throw deviceRes;            
            //console.log('[getDeviceData] deviceRes : ',deviceRes); //setDeviceInfo

            //Default Display 가져오기 - 기본
            const displayDefaultRes = await axios.get(`/device/default/display`);
            if (displayDefaultRes.code != '200') throw displayDefaultRes;         

            defaultWaveCodeListRef.current = displayDefaultRes.data.waveSettings;
            defaultNumericCodeListRef.current = displayDefaultRes.data.numericSettings;            

            const displayDefaultVsmRes = await axios.get(`/device/default/display?vsmMode=true`);
            defaultVsmNumericCodeListRef.current = displayDefaultVsmRes.data.numericSettings;

            const deviceDisplayRes = await axios.get(`/user/device/${deviceId}/display`);
            if (deviceDisplayRes.code != '200') throw deviceDisplayRes;

            setDeviceInfo(deviceRes.data);             
            setNumericArr(deviceDisplayRes.data.numericSettings)            
            setWaveArr(deviceDisplayRes.data.waveSettings)
            const speedSettings = deviceDisplayRes.data.waveSettings.map(ws => { return { parameter: ws.measureParameter, speed: ws.swapSpeed } })
            const newMeasurementSettings = { ...measurementSettings }
            speedSettings.forEach(ss => {
                if (ss.parameter && speedStringByType[ss.parameter]) {
                    newMeasurementSettings[speedStringByType[ss.parameter]] = ss.speed
                }
            })
            setMeasurementSettings(prev => {
                return {
                    ...prev,
                    ...newMeasurementSettings
                }
            })
            setVsmMode(deviceDisplayRes.data.vsmMode);
            displayOldInfo.current = {
                waveArr: deviceDisplayRes.data.waveSettings,
                numericArr: deviceDisplayRes.data.numericSettings,
                vsmMode: deviceDisplayRes.data.vsmMode,
                measurementSettings: { ...measurementSettings }
            }            

            //Wave Code List 가져오기
            const waveCodeRes = await axios.get(`/measure/parameters/wave`);
            if (waveCodeRes.code != '200') throw waveCodeRes;            
            //console.log('[getDeviceData] waveCodeRes : ',waveCodeRes); //setDeviceInfo
            
            setWaveCodeList(waveCodeRes.data.parameters);
            
            //Numeric Code List 가져오기
            const numericCodeRes = await axios.get(`measure/parameters/numeric`);
            if (numericCodeRes.code != '200') throw numericCodeRes;            
            //console.log('[getDeviceData] numericCodeRes : ',numericCodeRes); //setDeviceInfo
            
            setNumericCodeList(numericCodeRes.data.parameters);
        } catch (err) {
            console.warn(err)
        }   
    }

    //환자 저장 이후에 Device Data를 변경 해야 될 것 같아서 수정
    const handleDeviceDataChange = (newPatientId) => {
        setDeviceInfo(prev => ({
            ...prev,
            patientId: newPatientId
        }));
        getDeviceData(selectBedInfo.deviceId);
    };

    //as-is Device 선택 할 때 마다 Device 정보 가져와서 그려주기
    useEffect(() => {              
        if(selectBedInfo){
            getDeviceData(selectBedInfo.deviceId);
            //팝업창이 켜져있을 때 Device 이동 시 초기화 할 수 있게 설정.
            setConfirmTransfer({open : false,step : 1});
            setConfirmState({open : false,title : '', message : '', onYes : null , onNo : null});              
            
            const matchDeviceModel = deviceModelMenus.find(item => item.model === selectBedInfo.deviceModel);
            console.log('matchDeviceModel : ', matchDeviceModel)
            if(matchDeviceModel && matchDeviceModel.displayModify === false){
                setActiveTab('patientInfo');
                setIsShowDisplay(false)
            }else{
                setIsShowDisplay(true)
            }
        }  
    }, [selectBedInfo])

    //VSM Mode시 데이터 세팅
    useEffect(() => {    
        if (isFirstRender.current) {
            isFirstRender.current = false; // 초기 렌더링 후 플래그 업데이트
            return;
        }
        setVsmModeDisplay();
    }, [vsmMode])

    useEffect(() => {
        checkResetable()
    }, [waveArr, numericArr,defaultWaveCodeListRef.current,defaultNumericCodeListRef.current, measurementSettings])

    useEffect(() => {
        return () => {
            if (!isDisabledRef.current) {
                setBedInfo(prev => {
                    return prev.map(group => 
                        group.map(item => {
                            if (item.serial === selectBedInfo.serial) {
                                return { 
                                    ...item,
                                    waveCodeList: displayOldInfo.current.waveArr ? displayOldInfo.current.waveArr.map(ws => ws.measureParameter) : item.waveCodeList,
                                    numericCodeList: displayOldInfo.current.numericArr ? displayOldInfo.current.numericArr.map(ns => ns.measureParameter) : item.numericCodeList,
                                    vsmMode: displayOldInfo.current.vsmMode !== undefined ? displayOldInfo.current.vsmMode : item.vsmMode
                                }
                            } else {
                                return item
                            }
                        })
                    )
                })
                setMeasurementSettings(prev => {
                    return {
                        ...prev,
                        ...displayOldInfo.current.measurementSettings
                    }
                })
            }
        }
    }, [])
    
    return (
        <div className="relative w-full h-full bg-black max-h-[520px] font-normal border-t border-white">
            <div className="bg-[#1F1F1F] w-full h-full">
                <div className="flex relative justify-center text-white items-center h-[32px] bg-[#2C2C2C]">
                    <div className={`flex items-center px-2 py-1 bg-gradient-to-b ${'from-[#DEDEDE]'} ${'to-[#9F9F9F]'}`} style={{ height: '100%' }}>
                        <div className="flex items-center justify-center mr-2 text-black w-[178px]" style={{ fontWeight: 500, fontSize: 24, lineHeight: '26.4px' }}>{checkEmptyValue(selectBedInfo?.bedNumber.length <= 1 ? `0${selectBedInfo?.bedNumber}` : selectBedInfo?.bedNumber, 'BED-')}</div>                        
                        <div className="relative text-black truncate" style={{ fontWeight: 200, fontSize: 16, lineHeight: '17.6px', minWidth: 301, maxWidth: 301 }} title={ !selectBedInfo?.patientId ? 'Not Admitted' : (selectBedInfo?.nameDisplay === '1' ? checkEmptyValue(selectBedInfo?.patientName) : selectBedInfo?.nameDisplay === '2' ? checkEmptyValue(selectBedInfo?.devicePatientId) : selectBedInfo?.nameDisplay === '3' ? `${checkEmptyValue(selectBedInfo?.patientName)},${checkEmptyValue(selectBedInfo?.devicePatientId)}`: '-')}>
                            { !selectBedInfo?.patientId ? 'Not Admitted' : (selectBedInfo?.nameDisplay === '1' ? checkEmptyValue(selectBedInfo?.patientName) : selectBedInfo?.nameDisplay === '2' ? checkEmptyValue(selectBedInfo?.devicePatientId) : selectBedInfo?.nameDisplay === '3' ? `${checkEmptyValue(selectBedInfo?.patientName)} , ${checkEmptyValue(selectBedInfo?.devicePatientId)}`: '-')}
                        </div>
                    </div>
                    <HalfMenus 
                        selectBedInfo={selectBedInfo}
                        nowPage={'bedSetting'}
                        onTrend={onTrend}
                        onAlarmReview={onAlarmReview}
                        onMeasurements={onMeasurements}
                        onSetting={null}
                        isFull={null}
                        isFromSearch={false}
                        handleFullScreen={null}
                        onClose={onClose}
                    />
                </div>
                <div className="flex justify-between bg-black ">
                    <div className='flex gap-1 pt-1 text-lg'>
                        <button onClick={() => setActiveTab('patientInfo')} className={`w-[200px] h-[36px] rounded-t-md ${activeTab === 'patientInfo' ? 'text-white font-medium' : 'text-[#CECECE] font-light'}`} style={activeTab === 'patientInfo' ? activeTabStyle : inActiveTabStyle }>
                            {t('bedSetting.patient')}
                        </button>
                        <button onClick={() => setActiveTab('alarm')} className={`w-[200px] h-[36px] rounded-t-md ${activeTab === 'alarm' ? 'text-white font-medium' : 'text-[#CECECE] font-light'}`} style={ activeTab === 'alarm' ? activeTabStyle : inActiveTabStyle }>
                            {t('bedSetting.alarm')}
                        </button>
                        {
                            isShowDisplay && (
                                <button onClick={() => setActiveTab('display')} className={`w-[200px] h-[36px] rounded-t-md ${activeTab === 'display' ? 'text-white font-medium' : 'text-[#CECECE] font-light'}`} style={activeTab === 'display' ? activeTabStyle : inActiveTabStyle}>
                                    {t('bedSetting.display')}
                                </button>
                            )
                        }                        
                    </div>
                    
                    <div className="flex items-center gap-[8px] mr-[20px]">
                        {
                            activeTab == 'display' && (
                                <>
                                    <label className="flex gap-[4px] mt-[3px]">
                                        <input
                                            type="checkbox"
                                            checked={applyToAllBed}
                                            onChange={e => { setApplyToAllBed(e.target.checked); isDisabledRef.current = false }}
                                        />
                                        <span className="mb-[6px] font-light cursor-pointer text-white" style={{ lineHeight: '115%', paddingLeft: 4, fontSize: 14 }}>{t('bedSetting.applyToAll')}</span>
                                    </label>
                                    <div className="w-[1px] bg-[#444444] h-[24px]" />
                                    <button className={`w-[88px] h-[28px] pr-5 font-light relative rounded-[6px] ${!isResetable? 'bg-[#282828] text-[rgba(255,255,255,0.2)] cursor-default shadow-none' : ' text-white bg-gradient-to-b from-[#5E5E5E] to-[#383838] shadow-md transition-all duration-200'} active:from-[#4A4A4A] active:to-[#2B2B2B] active:shadow-sm`} disabled={!isResetable} onClick={() => {handleInit()}}>
                                        {t('bedSetting.reset')}
                                        <span className="absolute right-3 top-[4px]" style={{ opacity: isResetable ? 1 : 0.3 }}>
                                            <IconInit />
                                        </span>
                                    </button>
                                    <button className={`w-[88px] h-[28px] font-light relative rounded-[6px] ${isDisabledRef.current ? 'bg-[#282828] text-[rgba(255,255,255,0.2)] cursor-default shadow-none' : ' text-white bg-gradient-to-b from-[#5E5E5E] to-[#383838] shadow-md transition-all duration-200'} active:from-[#4A4A4A] active:to-[#2B2B2B] active:shadow-sm`} disabled={isDisabledRef.current} onClick={() => {handleDisplaySave()}}>{isDisabledRef.current ? t('bedSetting.saved') : t('bedSetting.save')}</button>                
                                </>
                            )
                        }
                    </div>
                </div>
                <div className="" style={{ height: 'calc(100% - 72px)' }}>
                    {renderTabContent()}
                </div>
            </div>

            {/* 기본 Confirm 창 */}
            {
                confirmState.open && <Confirm confirmState={confirmState} />   
            }

            {/* Transfer 환자 이동 Confirm 창 */}
            {
                confirmTransfer.open && <Transfer transferPatientInfo={transferPatientInfo} confirmTransfer={confirmTransfer} handleSetConfirmTransfer={handleSetConfirmTransfer} getDeviceData={getDeviceData} handleClose={handleClose} handleSaveParameter={handleSaveParameter}/>
            }            
        </div>
    );
};


export default BedSettingsModal;
